document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-add-to-cart]');
  if (!button) return;
  event.preventDefault();
  if (button.disabled) return;

  const variantId = button.dataset.variantId;
  const quantityInput = button.closest('form, [data-product-card]')?.querySelector('[data-quantity-input]');
  const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
  const originalLabel = button.textContent;

  button.disabled = true;

  try {
    const response = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    if (!response.ok) throw new Error('cart add failed');

    const cartResponse = await fetch(window.routes.cart_url + '.js');
    const cart = await cartResponse.json();
    document.querySelectorAll('.m-header__cart-badge').forEach((badge) => {
      badge.textContent = cart.item_count;
    });
    if (cart.item_count > 0) {
      document.querySelectorAll('.m-header__cart').forEach((cartLink) => {
        if (!cartLink.querySelector('.m-header__cart-badge')) {
          const badge = document.createElement('span');
          badge.className = 'm-header__cart-badge';
          badge.textContent = cart.item_count;
          cartLink.appendChild(badge);
        }
      });
    }

    const liveRegion = document.getElementById('massivo-cart-live-region');
    if (liveRegion) liveRegion.textContent = 'Producto agregado al carrito';

    button.textContent = 'Agregado ✓';
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 1400);
  } catch (error) {
    button.textContent = originalLabel;
    button.disabled = false;
  }
});
